import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';

/**
 * Generated class for the DishViewAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-products-stock',
    templateUrl: 'products-stock.html',
})
export class ProductsStockPage {
    @Input() element;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,) {
    }

}



// WEBPACK FOOTER //
// ./src/pages/ads/products-stock/products-stock.ts